import { propOr } from "ramda";
import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import PeopleRepository from "repositories/PeopleRepository";
import { getScore } from "utils/dateTimeUtils";
import { createCelebration } from "utils/calendarUtils";
import { deserialize } from "utils/storeUtils";
import { jjLogger } from "utils/logUtils";
import { DATE_TYPE } from "enums";

const initialState = {
  celebrations: [],
  meta: null,
};

const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  reducers: {
    loadCelebrationsSuccess(state, { payload }) {
      state.celebrations = payload;
      state.meta = propOr(null, "meta", payload);
    },
  },
});

export const { actions } = calendarSlice;
export default calendarSlice.reducer;

export const useCalendarActions = () => {
  const dispatch = useDispatch();

  const loadCelebrations = async ({ anniversaryParams, birthdayParams }) => {
    try {
      const responses = await Promise.all([
        PeopleRepository.index(anniversaryParams),
        PeopleRepository.index(birthdayParams),
      ]);
      const dataList = responses.map((response) => response.data);
      const anniversaryData = deserialize(dataList[0]);
      const birthdayData = deserialize(dataList[1]);
      let celebrations = [];

      const todayScore = getScore(new Date());
      const nextYearCelebrations = [];
      const currentYearCelebrations = [];

      anniversaryData.forEach((person) => {
        const celebration = createCelebration(person, DATE_TYPE.anniversary);
        if (todayScore > person.score) {
          nextYearCelebrations.push(celebration);
        } else {
          currentYearCelebrations.push(celebration);
        }
      });

      birthdayData.forEach((person) => {
        const celebration = createCelebration(person, DATE_TYPE.birthday);
        if (todayScore > person.score) {
          nextYearCelebrations.push(celebration);
        } else {
          currentYearCelebrations.push(celebration);
        }
      });

      currentYearCelebrations.sort(({ score: currentScore }, { score: nextScore }) => currentScore - nextScore);
      nextYearCelebrations.sort(({ score: currentScore }, { score: nextScore }) => currentScore - nextScore);

      celebrations = [...currentYearCelebrations, ...nextYearCelebrations];

      dispatch(calendarSlice.actions.loadCelebrationsSuccess(celebrations));
      return celebrations;
    } catch (error) {
      jjLogger.log(error);
      return error;
    }
  };

  return {
    loadCelebrations,
  };
};
